export default from './LocationQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/LocationQuestion/index.js